import { Stack, NumberInput, TextInput, Select, Button, Grid, Loader, Text, Flex } from '@mantine/core';
import { IconChevronRight, IconTrash } from '@tabler/icons-react';
import React, { useState } from 'react'

export default function AcademicSubscriptionForm({ form, loading }) {

   const [newFeatureText, setNewFeatureText] = useState('')

   const addFeature = () => {
      const features = [...(form?.values?.features || []), newFeatureText];
      form.setFieldValue('features', features)
      setNewFeatureText('')
   }

   const removeFeature = (text) => {
      const filteredFeatures = form.values.features.filter(item => item !== text)

      form.setFieldValue('features', () => filteredFeatures)
   }

   return (
      <Stack align='start' w='100%'>
         <Grid align='start' w='100%' spacing="md">
            <Grid.Col span={12}>
               <TextInput
                  label="Nombre"
                  placeholder="Nombre del plan"
                  required
                  {...form.getInputProps("name")}
               />
            </Grid.Col>

            <Grid.Col span={6} style={{ alignSelf: 'flex-end' }} >
               <NumberInput
                  label="Nivel"
                  min={1}
                  required
                  {...form.getInputProps("level")}
               />
            </Grid.Col>
            <Grid.Col span={6} >
               <Select
                  label="Estado"
                  data={[
                     {
                        value: "ACTIVA",
                        label: "Activa"
                     },
                     {
                        value: "INACTIVA",
                        label: "Inactiva"
                     }
                  ]}
                  description="Cuando está activa, se muestra en la web de ventas"
                  {...form.getInputProps("is_active")}
               />
            </Grid.Col>

            <Grid.Col span={6}>
               <NumberInput
                  label="Precio USD"
                  min={0}
                  decimalSeparator=','
                  step={0.1}
                  {...form.getInputProps("price.usd")}
               />

            </Grid.Col>

            <Grid.Col span={6}>
               <NumberInput
                  label="Precio ARS"
                  min={0}
                  decimalSeparator=','
                  {...form.getInputProps("price.ars")}
               />
            </Grid.Col>

            <Grid.Col span={12}>
               <Stack>
                  <h3 style={{ fontSize: 'var(--fs-body)', color: 'var(--color-text-primary)' }}>Características del plan</h3>
                  <Stack>
                     {form.values?.features && form.values?.features.length > 0 ? form.values?.features?.map((text, idx) => (
                        <Flex key={idx} justify='start' align='center' gap={16} >
                           <IconChevronRight />
                           <Text fz={'lg'} >
                              {text}
                           </Text>
                           <div style={{
                              border: "1px solid var(--color-red)",
                              padding: "4px 8px",
                              borderRadius: "var(--border-radius-md)",
                              cursor: 'pointer'
                           }} onClick={() => removeFeature(text)}>
                              <IconTrash color='var(--color-red)' />
                           </div>
                        </Flex>
                     )) : <Text fz={'lg'}>El plan no tiene ninguna característica</Text>}
                  </Stack>



               </Stack>
            </Grid.Col>

            <Grid.Col span={{ base: 12, sm: 8 }}>
               <TextInput
                  w='100%'
                  value={newFeatureText || ""}
                  onChange={event => setNewFeatureText(event.target.value)}
               />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 4 }}>
               <Button variant='outline' w='100%' type='button' onClick={addFeature} >
                  Agregar característica
               </Button>
            </Grid.Col>

            <Button type="submit" mt="lg">
               {loading ? <Loader /> : "Guardar suscripción"}
            </Button>
         </Grid>
      </Stack>
   );
}
